import { DataClass, DataItem } from 'scrivito'

import { debugLog } from './debugLog'
import { ErrorVariant } from '@/Components/error/constants'
import { APIErrorResponse } from '@/Data/types'

/**
 * Function that safely fetch a data item from data class
 * @param dataClass
 * @param id
 * @returns Returns `dataItem` if the request is successful, else `error` and `errorVariant`.
 */
export const getDataItem = (dataClass: DataClass, id: string) => {
  let error
  let dataItem: DataItem | null = null
  let errorVariant: ErrorVariant | undefined = undefined

  try {
    dataItem = dataClass.get(id)
  } catch (e) {
    debugLog(
      `>>> Error fetching id: ${id} from Data Class: ${dataClass.name()}\n`,
      e,
    )

    error = e as APIErrorResponse

    if (error.name === ErrorVariant.AccessDeniedError) {
      errorVariant = ErrorVariant.AccessDeniedError
    } else {
      errorVariant = ErrorVariant.UnknownError
    }
  }

  return { dataItem, error, errorVariant }
}
